import React, { Component } from 'react';
import Hero from './Hero';

class Home extends Component {
  render() {
    return (
      <div>
        <Hero>Planet-Scale Blockchain Services</Hero>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/App/Home/index.js